import { Injectable } from '@angular/core';
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { AuthenticationService } from '../services/auth.service';
import { AuthfakeauthenticationService } from '../services/authfake.service';

import { environment } from '../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard {
  constructor(
    private router: Router,
    private authenticationService: AuthenticationService,
    private authFackservice: AuthfakeauthenticationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean | Observable<boolean> {
    // Rutas públicas permitidas sin autenticación
    const publicRoutes = ['self-credit'];

    // Obtener el primer segmento de la URL desde state.url
    const currentRoute = state.url.split('/')[1]; // El primer segmento después de la barra "/"

    if (publicRoutes.includes(currentRoute)) {
      return true; // Permitir acceso sin autenticación
    }

    if (environment.defaultauth === 'firebase') {
      const currentUser = this.authenticationService.currentUser();
      if (
        currentUser &&
        currentUser.token &&
        currentUser.token !== 'undefined'
      ) {
        // logged in so return true
        return true;
      }
    } else {
      const currentUser = this.authFackservice.currentUserValue;
      if (
        currentUser &&
        currentUser.token &&
        currentUser.token !== 'undefined'
      ) {
        if (this.authFackservice.accessTokenNeedsRefresh()) {
          if (!this.authFackservice.hasRefreshToken()) {
            return this.redirectToLogin(state.url, true);
          }

          return this.authFackservice.refreshSession().pipe(
            map(() => true),
            catchError(() => of(this.redirectToLogin(state.url))),
          );
        }

        // logged in so return true
        return true;
      }
    }

    // not logged in so redirect to login page with the return url
    return this.redirectToLogin(state.url);
  }

  private redirectToLogin(returnUrl: string, closeSession = false): boolean {
    if (closeSession) {
      this.authFackservice.logout();
    }

    this.router.navigate(['/account/login-2'], {
      queryParams: { returnUrl },
    });
    return false;
  }
}
